import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import useSelectedPatient from '../patient/useSelectedPatient';

type AvailableDoses = {
    sopInstanceUID: string;
    label?: string;
    isLoaded: boolean;
    item?: DoseMatrix;
};

export default function useAvailableDoses(showSelected = false) {
    const patient = useSelectedPatient();
    const currentDose = useRecoilValue(currentDoseState);
    const [availableDoses, setAvailableDoses] = useState<AvailableDoses[]>([]);

    useEffect(() => {
        const loadedDoses = patient
            ? Array.from(patient.doses)
                  .filter(
                      (dose) =>
                          showSelected ||
                          dose.dicomUid !== currentDose?.dicomUid
                  )
                  .map((dose) => ({
                      sopInstanceUID: dose.dicomUid,
                      label: dose.plan?.label,
                      isLoaded: true,
                      item: dose,
                  }))
            : [];
        setAvailableDoses(loadedDoses);
    }, [patient, currentDose, showSelected]);

    return availableDoses;
}
